import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AssessmentRoutingModule } from './assessment-routing.module';
import { AssessmentComponent } from './assessment.component';
import { SharedModule } from '../shared/shared.module';
import { AssessmentGuidenessComponent } from './assessment-guideness/assessment-guideness.component';
import { AssessmentDescriptionComponent } from './assessment-description/assessment-description.component';
import { AssessmentTwoFaComponent } from './assessment-two-fa/assessment-two-fa.component';
import { AssessmentSettingsComponent } from './assessment-settings/assessment-settings.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AssessmentAuthComponent } from './assessment-auth/assessment-auth.component';
import { AssessmentQuestionComponent } from './assessment-question/assessment-question.component';
import { NgCircleProgressModule } from 'ng-circle-progress';


@NgModule({
  declarations: [
		AssessmentComponent,
		AssessmentGuidenessComponent,
		AssessmentDescriptionComponent,
		AssessmentTwoFaComponent,
		AssessmentSettingsComponent,
		AssessmentAuthComponent,
		AssessmentQuestionComponent
	],
  imports: [
    CommonModule,
    AssessmentRoutingModule,
		NgCircleProgressModule.forRoot(),
		SharedModule,
		PdfViewerModule,
		NgOtpInputModule
  ]
})
export class AssessmentModule { }
